import {
	Box,
	Button,
	Grid,
	Link,
	List,
	ListItem,
	ListItemText,
	Paper,
	Typography,
} from '@mui/material';
import { FC } from 'react';

export const NoGpsrBanner: FC = () => {
	return (
		<Paper
			sx={{
				margin: '0px 20px 20px 20px',
				padding: '10px 20px 0 20px',
				overflowX: 'auto',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				// alignItems: 'center',
				// width: '100%',
				gap: 1,
				backgroundColor: '#0092de24',
				borderRadius: '12px',
				p: '20px',
			}}
		>
			{/* <Notice text="GPSR is a service that provides real-time information about the availability of products in your warehouse." /> */}
			<Grid container spacing={1}>
				<Grid item xs={12} lg={8}>
					<Typography
						variant="h2"
						color="primary"
						sx={{
							fontSize: '1.3rem',
							fontWeight: 'bold',
						}}
					>
						What is the GPSR?
					</Typography>
					<Typography
						component="p"
						color="primary"
						sx={{
							fontSize: '1rem',
						}}
					>
						The <b>General Product Safety Regulation (GPSR)</b> applies to all non-food consumer
						products sold in the EU, ensuring they are safe, correctly labeled, and meet regulatory
						standards. It impacts industries like clothing, electronics, books, and home goods.
					</Typography>
					<Typography
						component="p"
						color="primary"
						sx={{
							fontSize: '1rem',
						}}
					>
						If you sell these products in the EU, they must meet <b>GPSR</b> requirements.
						Non-compliance can lead to product delisting, fines, and loss of market access.
					</Typography>
					<Typography
						variant="h2"
						color="primary"
						sx={{
							fontSize: '1.3rem',
							fontWeight: 'bold',
							mt: 2,
						}}
					>
						Who Needs to Comply with GPSR?
					</Typography>
					<Typography
						component="p"
						color="primary"
						sx={{
							fontSize: '1rem',
						}}
					>
						Any non-EU company selling consumer goods into the EU must ensure their products meet
						<b>GPSR</b> requirements. This includes:
					</Typography>
					<List
						sx={{
							m: '0 0 0 20px',
							p: 0,
							'& .MuiTypography-root': {
								color: 'primary.main',
							},
							'& .MuiTypography-body1': {
								fontWeight: 'bold',
							},
							'& .MuiListItemText-root': {
								fontSize: '1rem',

								margin: 0,
								padding: 0,
							},
							'& .MuiListItem-root': {
								padding: 0,
							},
							'& .MuiListItem-root + .MuiListItem-root': {
								marginTop: 1,
							},
						}}
					>
						<ListItem>
							<ListItemText
								primary="Manufacturers and Brands"
								secondary="outside the EU who sell directly to EU consumers"
							/>
						</ListItem>
						<ListItem>
							<ListItemText
								primary="Importers"
								secondary="who bring non-EU products into the EU market"
							/>
						</ListItem>
						<ListItem>
							<ListItemText
								primary="Resellers and Distributors"
								secondary="who sell products manufactured outside the EU"
							/>
						</ListItem>
					</List>
					<Typography
						component="p"
						color="primary"
						sx={{
							fontSize: '1rem',
							mt: 2,
						}}
					>
						<b>Important Note for Resellers:</b> If you are a reseller, your manufacturer may handle
						<b>GPSR</b> compliance. However, if they do not, the responsibility falls on you to
						ensure compliance. It’s essential to verify with your manufacturer whether they have
						appointed an <b>EU representative</b> and are meeting all <b>GPSR</b> requirements. If
						not, you will need to take the necessary steps to comply.
					</Typography>
				</Grid>
				<Grid item xs={false} lg={4} display={{ xs: 'none', lg: 'block' }}>
					<img
						src="/img/EU_flag_color.jpeg"
						alt=""
						style={{
							width: '100%',
							borderRadius: '12px',
						}}
					/>
				</Grid>
			</Grid>

			{/* <Typography
				variant="h2"
				color="primary"
				sx={{
					fontSize: '1.3rem',
					fontWeight: 'bold',
				}}
			>
				What is the GPSR?
			</Typography>
			<Typography
				component="p"
				color="primary"
				sx={{
					fontSize: '1rem',
				}}
			>
				The <b>General Product Safety Regulation (GPSR)</b> applies to all non-food consumer
				products sold in the EU, ensuring they are safe, correctly labeled, and meet regulatory
				standards. It impacts industries like clothing, electronics, books, and home goods.
			</Typography>
			<Typography
				component="p"
				color="primary"
				sx={{
					fontSize: '1rem',
				}}
			>
				If you sell these products in the EU, they must meet GPSR requirements. Non-compliance can
				lead to product delisting, fines, and loss of market access.
			</Typography>

			<Typography
				variant="h2"
				color="primary"
				sx={{
					fontSize: '1.3rem',
					fontWeight: 'bold',
					mt: 2,
				}}
			>
				Who Needs to Comply with GPSR?
			</Typography>
			<Typography
				component="p"
				color="primary"
				sx={{
					fontSize: '1rem',
				}}
			>
				Any non-EU company selling consumer goods into the EU must ensure their products meet GPSR
				requirements. This includes:
			</Typography>
			<List
				sx={{
					m: '0 0 0 20px',
					p: 0,
					'& .MuiTypography-root': {
						color: 'primary.main',
					},
					'& .MuiTypography-body1': {
						fontWeight: 'bold',
					},
					'& .MuiListItemText-root': {
						fontSize: '1rem',

						margin: 0,
						padding: 0,
					},
					'& .MuiListItem-root': {
						padding: 0,
					},
					'& .MuiListItem-root + .MuiListItem-root': {
						marginTop: 1,
					},
				}}
			>
				<ListItem>
					<ListItemText
						primary="Manufacturers and Brands"
						secondary="outside the EU who sell directly to EU consumers"
					/>
				</ListItem>
				<ListItem>
					<ListItemText
						primary="Importers"
						secondary="who bring non-EU products into the EU market"
					/>
				</ListItem>
				<ListItem>
					<ListItemText
						primary="Resellers and Distributors"
						secondary="who sell products manufactured outside the EU"
					/>
				</ListItem>
			</List>
			<Typography
				component="p"
				color="primary"
				sx={{
					fontSize: '1rem',
				}}
			>
				Important Note for Resellers: If you are a reseller, your manufacturer may handle GPSR
				compliance. However, if they do not, the responsibility falls on you to ensure compliance.
				It’s essential to verify with your manufacturer whether they have appointed an EU
				representative and are meeting all GPSR requirements. If not, you will need to take the
				necessary steps to comply.
			</Typography> */}

			<Grid
				container
				spacing={1}
				sx={{
					mt: 2,
					width: '100%',
				}}
			>
				<Grid item xs={12} lg={6}>
					<Button
						variant="contained"
						color="primary"
						href="https://help.easproject.com/gpsr"
						target="_blank"
						fullWidth
						// sx={{ width: '100%' }}
					>
						Read more about GPSR and how to add the information to your sales channels
					</Button>
				</Grid>
				<Grid item xs={12} lg={6}>
					<Button
						variant="contained"
						color="primary"
						href="https://easproject.com/gpsr/#gpsrpricing"
						target="_blank"
						fullWidth
						// sx={{ width: '100%' }}
					>
						GPSR pricing
					</Button>
				</Grid>
			</Grid>

			{/* <Button
				variant="contained"
				color="primary"
				href="https://help.easproject.com/gpsr"
				target="_blank"
				sx={{
					marginTop: 2,
				}}
			>
				Read more about GPSR and how to add the information to your sales channels
			</Button>
			<Button
				variant="contained"
				color="primary"
				href="https://easproject.com/gpsr/#gpsrpricing"
				target="_blank"
				sx={{
					marginTop: 2,
				}}
			>
				GPSR pricing
			</Button> */}

			{/* <Typography
				variant="h2"
				color="primary"
				sx={{
					fontSize: '1.3rem',
					fontWeight: 'bold',
					mt: 2,
				}}
			>
				Read more about GPSR and how to add the information to your sales channels:
			</Typography>
			<Link
				color="primary"
				sx={{
					fontSize: '1.3rem',
					textDecoration: 'none',
					'&:hover': {
						textDecoration: 'underline',
					},
				}}
				href="https://help.easproject.com/gpsr"
				target="_blank"
			>
				help.easproject.com/gpsr
			</Link>
			<Typography
				variant="h2"
				color="primary"
				sx={{
					mt: 2,
					fontSize: '1.3rem',
					fontWeight: 'bold',
				}}
			>
				GPSR pricing:{' '}
			</Typography>
			<Link
				href="https://easproject.com/gpsr/#gpsrpricing"
				sx={{
					fontSize: '1.3rem',
					textDecoration: 'none',
					'&:hover': {
						textDecoration: 'underline',
					},
				}}
				target="_blank"
			>
				easproject.com/gpsr/#gpsrpricing
			</Link> */}
		</Paper>
	);
};
